import React, { createContext, useContext, useMemo, useState, useEffect } from "react";

export const EXPANDED_SIDEBAR_WIDTH = 248;
export const COLLAPSED_SIDEBAR_WIDTH = 52;

const LayoutContext = createContext({
  isSidebarCollapsed: false,
  toggleSidebar: () => {},
  expandedWidth: EXPANDED_SIDEBAR_WIDTH,
  collapsedWidth: COLLAPSED_SIDEBAR_WIDTH,
  isMobileMenuOpen: false,
  toggleMobileMenu: () => {},
  closeMobileMenu: () => {},
  isMobile: false,
});

export const LayoutProvider = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen size (< 1024px)
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      // Close mobile menu when switching to desktop
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const value = useMemo(
    () => ({
      isSidebarCollapsed,
      toggleSidebar,
      expandedWidth: EXPANDED_SIDEBAR_WIDTH,
      collapsedWidth: COLLAPSED_SIDEBAR_WIDTH,
      isMobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      isMobile,
    }),
    [isSidebarCollapsed, isMobileMenuOpen, isMobile]
  );

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
